import React from 'react';
import { Box, Alert } from '@mui/material';
import { DataGrid, GridColDef, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';

interface DataTableProps {
  rows: any[]; // Data rows
  columns: GridColDef[]; // Column definitions
  loading?: boolean;
  error?: string | null;
  rowCount?: number; // Total number of rows for server-side pagination
  paginationModel?: GridPaginationModel; // Current page and page size
  onPaginationModelChange?: (model: GridPaginationModel) => void;
  sortModel?: GridSortModel; // Current sort model
  onSortModelChange?: (model: GridSortModel) => void;
  paginationMode?: 'client' | 'server';
  sortingMode?: 'client' | 'server';
  getRowId: (row: any) => string | number; // Function to get unique ID for each row
}

const DataTable: React.FC<DataTableProps> = ({
  rows,
  columns,
  loading = false,
  error = null,
  rowCount,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  paginationMode = 'client',
  sortingMode = 'client',
  getRowId,
}) => {

  if (error) {
    return <Alert severity="error">Error loading data: {error}</Alert>;
  }

  return (
    <Box sx={{ height: 600, width: '100%' }}> {/* Adjust height as needed */}
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}
        pageSizeOptions={[10, 20, 50]} // Common page size options
        // Server-side pagination props
        rowCount={rowCount} // Pass total row count if using server-side pagination
        paginationModel={paginationModel} // Control page/pageSize
        onPaginationModelChange={onPaginationModelChange} // Handle page changes
        paginationMode={paginationMode}
        // Server-side sorting props
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}
        sortingMode={sortingMode}
        // Row ID
        getRowId={getRowId}
        // Optional features
        checkboxSelection={false} // Disable row selection if not needed
        disableRowSelectionOnClick
        disableColumnMenu
        // Density toggle (optional)
        // slots={{ toolbar: GridToolbar }} // Add toolbar for filtering, density, etc. if needed
        sx={{ 
          // Prevent header overflow issues
          '& .MuiDataGrid-columnHeaderTitle': { 
            overflow: 'visible',
            lineHeight: '1.43rem',
            whiteSpace: 'normal',
          },
        }}
      />
    </Box>
  );
};

export default DataTable; 